module.exports = __webpack_public_path__ + "static/media/07.f74e6226.jpeg";